import { bankApi } from '@/api'
import { IPageInfoRequest, IPageInfoResponse } from '@/domains/CommonDomain'
import {
  IScheduledTransfer,
  IScheduledTransferDetail,
  IScheduledTransferHistory,
  ISchedulePaymentIdentity,
} from '@/domains/SchedulePaymentDomain'

const BASE = '/scheduled-transfer'

export const SCHEDULE_PAYMENT_API_URL = {
  REGISTER: 'scheduled-transfer/register',
  CANCEL: 'scheduled-transfer/cancel',
}

export interface IScheduledTransferDetailRequest extends ISchedulePaymentIdentity {}

export interface ICancelScheduledTransferRequest extends ISchedulePaymentIdentity {}

export interface IFindScheduledTransfersResponse {
  pageInfo: IPageInfoResponse
  scheduledTransfers: IScheduledTransfer[]
}

export const fetchScheduleList = (
  data: IPageInfoRequest,
): Promise<IFindScheduledTransfersResponse> => {
  return bankApi.post(`${BASE}`, data)
}

export const fetchScheduledTransfer = (
  data: ISchedulePaymentIdentity,
): Promise<IScheduledTransferDetail> => {
  return bankApi.post(`${BASE}/detail`, data)
}

export interface IFindScheduledTransferHistoriesResponse {
  scheduledTransferHistories: IScheduledTransferHistory[]
  pageInfo: IPageInfoResponse
}

export const fetchScheduleHistoryList = (
  data: IPageInfoRequest,
): Promise<IFindScheduledTransferHistoriesResponse> => {
  return bankApi.post(`${BASE}/history`, data)
}

export const fetchScheduleHistoryDetail = (data: ISchedulePaymentIdentity) => {
  return bankApi.post(`${BASE}/history/detail`, data)
}
